import { FlowActions } from '../types';

const hiddenRuleActionArguments: Partial<Record<FlowActions, string[]>> = {
  [FlowActions.AccessDoor]: ['accessTime', 'extended'],
  // Placeholder — the intrusion actions don't exist in `getFlowActions` yet, so this
  // argument name/presence is unconfirmed. If the backend derives the panel from the
  // partition/zone (matching the door actions' pattern), `deviceID` should stay hidden here.
  [FlowActions.ArmPartition]: ['deviceID'],
  [FlowActions.BypassZone]: ['deviceID']
};

export function isRuleActionArgumentHidden(actionName: string, argumentName: string): boolean {
  return !!hiddenRuleActionArguments[actionName as FlowActions]?.includes(argumentName);
}
